export const SESSION_STORAGE_PSA = 'PSA';
export const SESSION_STORAGE_PSA_ID = 'PSA_ID';
export const SESSION_STORAGE_TICKET_ID = 'TICKET_ID';
export const SESSION_STORAGE_SCREEN = 'SCREEN';
export const SESSION_STORAGE_URL = 'url';
